module.exports = __webpack_public_path__ + "img/bo.1fbbe93d.svg";